import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import React from 'react';
const DaysContainer = _styled("div", {
  target: "e1ah1bge0",
  label: "DaysContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1y6e8q",
  styles: "margin-left:30px;"
} : {
  name: "1y6e8q",
  styles: "margin-left:30px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const CustomDaysSelection = _ref => {
  let {
    days
  } = _ref;
  const dayMap = {};
  if (days) {
    days.forEach(day => {
      dayMap[day] = true;
    });
  }
  const checkboxFields = [{
    value: 'monday',
    defaultIsChecked: !!dayMap.monday,
    label: 'Monday'
  }, {
    value: 'tuesday',
    defaultIsChecked: !!dayMap.tuesday,
    label: 'Tuesday'
  }, {
    value: 'wednesday',
    defaultIsChecked: !!dayMap.wednesday,
    label: 'Wednesday'
  }, {
    value: 'thursday',
    defaultIsChecked: !!dayMap.thursday,
    label: 'Thursday'
  }, {
    value: 'friday',
    defaultIsChecked: !!dayMap.friday,
    label: 'Friday'
  }, {
    value: 'saturday',
    defaultIsChecked: !!dayMap.saturday,
    label: 'Saturday'
  }, {
    value: 'sunday',
    defaultIsChecked: !!dayMap.sunday,
    label: 'Sunday'
  }];
  return /*#__PURE__*/React.createElement(DaysContainer, null, checkboxFields.map(_ref2 => {
    let {
      value,
      defaultIsChecked,
      label
    } = _ref2;
    return /*#__PURE__*/React.createElement(CheckboxField, {
      name: "days",
      value: value,
      defaultIsChecked: defaultIsChecked,
      key: value
    }, _ref3 => {
      let {
        fieldProps
      } = _ref3;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        label: label
      }));
    });
  }));
};
export default CustomDaysSelection;